import store from '@/store/store'
import useI18nGlobal from '@/utils/i18n';
const {i18n} = useI18nGlobal();
const { t } = i18n.global;
export default function (editor, context, callback){
    async function _onAction(){
        callback(); // set edited node
        await store.dispatch('externalContent/contentContextSet', context);
        await store.dispatch('externalContent/contentChoosingSet', true);
        await store.dispatch('mediaContent/setEditorActive', editor.id); // to insert content accordingly
    }

    editor.ui.registry.addIcon('external-content',
        `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="20" height="20" fill="#1D9B9B" style="fill: #1d9b9b !important;"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128zM571 308l-95.7-96.4c-10.1-10.1-27.4-3-27.4 11.3V288h-64v64h64v65.2c0 14.3 17.3 21.4 27.4 11.3L571 332c6.6-6.6 6.6-17.4 0-24zm-379 28v-32c0-8.8 7.2-16 16-16h176V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V352H208c-8.8 0-16-7.2-16-16z"/></svg>`
    );

    editor.ui.registry.addButton('external-content', {
        tooltip: t('popup.external.tooltip'),
        icon: 'external-content',
        onAction: _onAction
    });

    editor.ui.registry.addMenuItem('external-content', {
        context: 'insert',
        text: t('popup.external.tooltip'),
        icon: 'external-content',
        onAction: _onAction
    });
}